export const getValueClassName = (value, threshold) => {
    if (!value || !threshold) return '';
    if (value >= threshold.highThreshold) {
        return 'highThreshold';
    }
    if (value > threshold.mediumThreshold && value < threshold.highThreshold) {
        return 'mediumThreshold';
    }
    if (value <= threshold.mediumThreshold) {
        return 'lowThreshold';
    }
    return '';
};
